import * as React from 'react'

import { Check } from 'lucide-react'

import { cn } from '@/lib/utils'

interface IProps {
  icon?: React.ReactNode
  label: React.ReactNode
  selected?: boolean
  onClick?: () => void
  reserveIconSlot?: boolean
  trailing?: React.ReactNode
  // 'button' for navigation rows that sit outside a listbox.
  role?: 'option' | 'button'
}

const OptionsItem: React.FC<IProps> = ({
  icon,
  label,
  selected,
  onClick,
  reserveIconSlot,
  trailing,
  role = 'option',
}) => {
  return (
    <button
      type="button"
      role={role === 'option' ? 'option' : undefined}
      aria-selected={role === 'option' ? selected || undefined : undefined}
      onClick={onClick}
      className={cn(
        'tw:flex tw:w-full tw:items-center tw:gap-2 tw:rounded-md tw:pl-1.5 tw:pr-2 tw:py-1 tw:text-left tw:text-app-dense tw:outline-none tw:transition-colors',
        'tw:bg-transparent tw:border-0 tw:cursor-pointer tw:text-inherit tw:appearance-none',
        'tw:hover:bg-accent tw:hover:text-accent-foreground tw:focus-visible:bg-accent tw:focus-visible:text-accent-foreground',
        selected && 'tw:bg-accent tw:text-accent-foreground',
      )}
    >
      {(icon || reserveIconSlot) && (
        <span className="tw:inline-flex tw:size-4 tw:shrink-0 tw:items-center tw:justify-center tw:text-muted-foreground">
          {icon}
        </span>
      )}
      <span className="tw:flex-1 tw:truncate">{label}</span>
      {trailing !== undefined
        ? trailing
        : selected && (
            <Check className="tw:size-4 tw:shrink-0 tw:text-foreground" />
          )}
    </button>
  )
}

export default OptionsItem
